export const SubscriptionColors: Record<string, string> = {
	TRIAL: 'primary',
	ACTIVE: 'green',
	CANCELLED: 'red',
	CANCELLING: 'red',
	SWITCHING: 'violet',
	PENDING: 'violet',
	NONE: 'gray',
	CANCELLED_TRIAL: 'red',
	CANCELLED_SUBSCRIPTION: 'red',
	TRIAL_NOT_STARTED: 'gray'
}

import colors from 'tailwindcss/colors'

export const color = (name: string, v?: number) => {
	const shade = v || 500
	const customVars = [
		'primary',
		'neon',
		'cherry',
		'sea',
		'yellow',
		'rose',
		'violet'
	]
	if (customVars.includes(name)) {
		return `var(--color-${name}-${shade})`
	}
	// Separate --chart-* family, NOT the --color-* ramps: those light values
	// differ from the tailwindcss/colors hexes this function returned before
	// theme routing, and both sets of consumers keep their light rendering.
	const chartVars = ['red', 'green', 'gray', 'amber', 'purple']
	if (chartVars.includes(name)) {
		return `var(--chart-${name}-${shade})`
	}
	if (name === 't') {
		return `var(--color-text-${v})`
	}
	if (name === 'custom') {
		return v as any
	}
	const _col = colors as any
	if (_col[name] && _col[name][shade]) {
		return _col[name][shade]
	}
	return name
}

export const defaultPlatformColor = (platform: 'GADS' | 'FADS' | 'BADS') => {
	if (platform === 'GADS') return color('red', 500)
	if (platform === 'FADS') return color('blue', 500)
	if (platform === 'BADS') return color('green', 500)
	return color('red', 500)
}
